<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g>
      <g>
        <rect width="24" height="24" fill="none"/>
      </g>
      <g>
        <g>
          <rect id="Rectangle_51" data-name="Rectangle 51" width="4" height="20" transform="translate(5.25 8.069) rotate(-44.968)"/>
          <rect id="Rectangle_52" data-name="Rectangle 52" width="4" height="8" transform="matrix(0.707, -0.707, 0.707, 0.707, 9.486, 3.827)"/>
          <rect id="Rectangle_53" data-name="Rectangle 53" width="4" height="8" transform="translate(0.999 12.315) rotate(-45)"/>
          <rect id="Rectangle_54" data-name="Rectangle 54" width="12" height="2" transform="translate(1 21)"/>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "showcontracticon"
})
</script>